(function () {
  'use strict';
  var incoming = new URLSearchParams(location.search);
  var page = (window.AL_PX || {}).landingPage;
  if (['adv', 'list', 'adv-qc', 'six-reasons'].indexOf(page) === -1) return;
  var index = 0;
  document.querySelectorAll('a[href]').forEach(function (link) {
    var next;
    try { next = new URL(link.href, location.href); } catch (e) { return; }
    if (next.origin !== location.origin || next.pathname.indexOf('/products/') !== 0) return;
    next.searchParams.set('al_page', page);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'ms_optout'].forEach(function (key) {
      if (incoming.has(key)) next.searchParams.set(key, incoming.get(key));
    });
    link.href = next.toString();
    link.dataset.alLandingCta = String(++index);
  });
}());
